import * as fromDatatype from '../datatype-library/index';

export interface bl_pos_hold_bill_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  customer_hdr_guid: fromDatatype.GuidDataFieldInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  txn_amount: fromDatatype.NumericDatatypeClass;
  line_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_pos_hold_bill_hdr_RowClass implements bl_pos_hold_bill_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  comp_hdr_guid: fromDatatype.GuidDataFieldInterface;
  branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  gendoc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  customer_hdr_guid: fromDatatype.GuidDataFieldInterface;
  remarks: fromDatatype.TextDatatypeInterface;
  txn_amount: fromDatatype.NumericDatatypeClass;
  line_json: fromDatatype.JsonDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}